<template>
<div>
    <div class="rules">
        <div class="body__bg" ref="bodyOpacity"></div>
        <vHeader @enableDimming="enableDimming" @closeDimming="closeDimming()" @headerModelOpen="headerModelOpen"></vHeader>
        <div class="container">
            <div class="rules__arrow-1">
                <img src="/img/arrow-spiral-3.svg" alt="" />
            </div>
            <div class="rules__bg-1">
                <img src="/img/list-bg-4.png" alt="" />
            </div>
            <div class="rules__bg-2">
                <img src="/img/list-bg-3.png" alt="" />
            </div>
            <div class="rules__bg-3">
                <img src="/img/list-bg-2.png" alt="" />
            </div>
            <h2 class="rules__title">Правила и условия</h2>
            <div class="rules__block">
                <div class="rules__block-text">
                    Настоящий договор, адресован Клиентам и является официальным и
                    публичным предложением Компании, предмет и условия которого указаны
                    в соответствующем разделе сайта www.dieedid.ee. Клиент, принимая
                    условия настоящего договора (далее – Договор) принимает условия о
                    нижеследующем:
                </div>
                <div class="rules__block-item">
                    <div class="rules__block-subtitle">Термины: <div class="rules__block-subtitle-inner">T</div>
                    </div>
                    <ul class="rules__block-ul">
                        <li class="rules__block-li">
                            Программа Питания или Продукт – предложение Компании о продаже
                            программы питания для Клиента
                        </li>
                        <li class="rules__block-li">
                            Заказ – соответствующим образом оформленный и оплаченный заказ
                            Клиента Продавцу.
                        </li>
                        <li class="rules__block-li">
                            Клиент – дееспособное физическое лицо, которое является
                            гражданином Эстонии или иного государства, размещающее заказы и
                            приобретающее Продукты, которые представлены на сайте в сети
                            Интернет www.dieedid.ee, для своих личных целей, не связанных с
                            осуществлением предпринимательской деятельности.
                        </li>
                        <li class="rules__block-li">
                            Компания (или сайт www.dieedid.ee) – юридическое лицо,
                            учрежденное в соответствии с Законодательством Эстонской
                            Республики, оперирующее сайтом www.dieedid.ee.
                        </li>
                        <li class="rules__block-li">
                            Сайт – сайт Компании, расположенный по адресу www.dieedid.ee и
                            содержащий все признаки публичной оферты.
                        </li>
                    </ul>
                </div>
                <div class="rules__block-item">
                    <div class="rules__block-subtitle">Общие положения <div class="rules__block-subtitle-inner">1</div>
                    </div>
                    <ul class="rules__block-ul">
                        <li class="rules__block-li">
                            Заказывая Продукт через Сайт, Клиент безоговорочно соглашается с
                            условиями настоящего Договора, изложенными ниже.
                        </li>
                        <li class="rules__block-li">
                            Настоящий Договор, также информация о Продукте, представленная
                            на Сайте, являются публичной офертой.
                        </li>
                        <li class="rules__block-li">
                            Компания имеет право без предварительного уведомления вносить
                            изменения в данный Договор. Изменения условий Договора вступают
                            в силу после их публикации на Сайте и применяются к любому
                            Заказу, сделанному после публикации.
                        </li>
                        <li class="rules__block-li">
                            Клиент соглашается на передачу Компании своих личных данных (как
                            это предусмотрено в Разделе 6 данного Договора), информации по
                            Заказу, и соглашается соблюдать условия Договора путем
                            заполнения граф в соответствующих колонках при оформлении Заказа
                            на Сайте.
                        </li>
                    </ul>
                </div>
                <div class="rules__block-item">
                    <div class="rules__block-subtitle">Информация о Продукте <div class="rules__block-subtitle-inner">2</div>
                    </div>
                    <ul class="rules__block-ul">
                        <li class="rules__block-li">
                            Информаци я о Продукте размещается на Сайте www.dieedid.ee и
                            предоставляется Компанией.
                        </li>
                        <li class="rules__block-li">
                            Все распространяемые Продукты введены в гражданский оборот
                            надлежащим способом и не нарушают никакие права третьих лиц.
                        </li>
                        <li class="rules__block-li">
                            Вся текстовая информация и графические изображения Продуктов,
                            размещаемых на Сайте, являются собственностью Компании.
                            программное обеспечение, ссылки на WEB ресурсы, которые могут
                            нанести кому-либо вред, а так же не совершать на Сайте иные
                            действия не соответствующие нормам морали и законодательства.
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <vFooter></vFooter>
    <vHeaderModel v-if="showModelHeader"></vHeaderModel>
</div>
</template>

<script>
import vHeader from "./v-header";
import vFooter from "./v-footer";
import vHeaderModel from './v-enter-model'

export default {
    name: "rules",
    data() {
        return {
            showModelHeader: false
        }
    },
    components: {
        vHeader,
        vFooter,
        vHeaderModel,
    },
    methods: {
        enableDimming() {
            this.$refs.bodyOpacity.style.display = 'block';
        },
        closeDimming() {
            this.$refs.bodyOpacity.style.display = 'none';
        },
        headerModelOpen() {
            this.showModelHeader = true;
            this.$refs.bodyOpacity.onclick = () => {
                this.showModelHeader = false;
                this.closeDimming()
            }
        }
    },
    mounted() {
        document.querySelector('.rules').style.opacity = '1';
    }
};
</script>

<style>
body {
    background-image: url(/img/fon.jpg);
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
}

.footer {
    color: #fff;
}

.rules {
    background-image: url(/img/wave-bg-3.png);
    background-position: top center;
    background-repeat: no-repeat;
    min-height: 995px;
    margin-top: -35px;
    opacity: 0;
    transition: all .4s;
}

.rules .header {
    margin-top: 69px;
}

.rules .container {
    position: relative;
}

.rules__arrow-1,
.rules__bg-1,
.rules__bg-2,
.rules__bg-3 {
    position: absolute;
    z-index: -1;
}

.rules__arrow-1 {
    top: 40%;
    left: 0;
    transform: rotate(30deg);
}

.rules__bg-1 /img {
    width: 150px;
    height: 101px;
}

.rules__bg-1 {
    top: 30%;
    right: -10%;
    transform: rotate(160deg);
}

.rules__bg-2 {
    bottom: -3%;
    right: -20%;
    transform: rotate(0deg);
}

.rules__bg-3 {
    left: -33%;
    top: 27%;
    transform: rotate(-110deg);
}

.rules__title {
    color: #fff599;
    font-family: "Roboto-Bold";
    font-size: 73.9556px;
    line-height: 85px;
    margin-top: 20px;
    margin-bottom: 18px;
    text-align: center;
}

.rules__block {
    background: rgba(255, 255, 255, 0.8);
    padding: 23px 72px 23px 64px;
    max-width: 980px;
    margin: 0 auto;
    min-height: 700px;
    margin-bottom: 20px;
}

.rules__block-text {
    margin-bottom: 40px;
}

.rules__block-li,
.rules__block-text {
    font-size: 14px;
    line-height: 14px;
    font-family: "Roboto-Light";
    color: #000000;
    max-width: 850px;
    position: relative;
}

.rules__block-li {
    padding-left: 8px;
    margin-bottom: 11px;
}

.rules__block-li:before {
    content: '';
    position: absolute;
    height: 3px;
    width: 3px;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
    background: black;
    border-radius: 50%;
}

.rules__block-subtitle {
    font-size: 14px;
    list-style: 14px;
    color: #277D2A;
    font-family: "Roboto-Bold";
    margin-bottom: 14px;
    position: relative;
}

.rules__block-subtitle-inner {
    position: absolute;
    font-family: "Roboto-Bold";
    width: 33px;
    height: 70px;
    background: #8EBB17;
    top: -10px;
    left: -45px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 17.6203px;
    line-height: 17px;
    padding-bottom: 10px;
}

.rules__block-item {
    margin-bottom: 20px;
}

@media (max-width: 1660px) {
    .rules {
        overflow: hidden;
    }
}

@media (max-width: 1400px) {
    .rules__arrow-1 {
        display: none;
    }
}

@media (max-width: 1000px) {
    .rules__bg-3 /img {
        width: 122px;
    }

    .rules__bg-3 {
        left: -2%;
        bottom: -9%;
        transform: rotate(0);
        height: 100px;
        top: auto;
    }

    .rules__block {
        margin-bottom: 50px;
    }

    .rules__bg-1 /img {
        width: 190px;
        height: auto;
    }

    .rules__bg-1 {
        top: 5%;
        right: -5%;
        transform: rotate(0);
    }

    .rules__title {
        margin-top: 15px;
        font-size: 65px;
    }

    .rules {
        background-position: bottom center;
    }
}

@media (max-width: 600px) {
    .rules__title {
        font-size: 50px;
    }
}

@media (max-width: 500px) {
    .rules__title {
        font-size: 30px;
        margin-bottom: 5px;
        line-height: 35px;
    }

    .rules__block {
        padding: 23px 29px 2px 32px;
    }

    .rules__block-subtitle-inner {
        width: 19px;
        height: 27px;
        font-size: 13px;
    }

    .rules__block-subtitle-inner {
        top: -8px;
        left: -22px;
        padding-bottom: 4px;
    }

    .rules__block-li,
    .rules__block-text {
        font-size: 12px;
    }
}
</style>
